import React, { createContext, useContext, useState, useCallback } from 'react';
import { Notification } from '../services/dataService';

interface NotificationContextType {
  showNotification: (notification: Notification) => void;
  currentNotification: Notification | null;
  clearNotification: () => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const useNotificationPopup = () => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotificationPopup must be used within a NotificationProvider');
  }
  return context;
};

interface NotificationProviderProps {
  children: React.ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const [currentNotification, setCurrentNotification] = useState<Notification | null>(null);

  const showNotification = useCallback((notification: Notification) => {
    setCurrentNotification(notification);
  }, []);

  const clearNotification = useCallback(() => {
    setCurrentNotification(null);
  }, []);

  return (
    <NotificationContext.Provider value={{
      showNotification,
      currentNotification,
      clearNotification
    }}>
      {children}
    </NotificationContext.Provider>
  );
}; 